module.exports = __webpack_public_path__ + "img/gift-info-1.5b2a50ba.png";